import React from 'react';
import Fade from '@mui/material/Fade';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import SvgMenu from './SvgMenu';
import { useGsapContextSafe } from '@/utils/hooks/useGsapScroll';
import { BASE_HEADER_HEIGHT } from '@/constants/profile-builder';
import { OptionType } from '@/types/common';

const GeneralMenu = (props: { menuList: OptionType[] }) => {
  const { menuList } = props;
  const [open, setOpen] = React.useState(false);
  const gsapContext = useGsapContextSafe();

  const handleScroll = (id: string) => {
    if (id) {
      gsapContext({
        scrollId: id,
        offsetY: BASE_HEADER_HEIGHT,
      });
    }
    setOpen(false);
  };

  return (
    <div className="absolute top-0 -left-16 h-full">
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <div className="sticky top-16 flex z-10">
          <SvgMenu
            type="button"
            className="cursor-pointer mb-3"
            onClick={() => setOpen(!open)}
          />
          <Fade in={open} timeout={{ enter: 250, exit: 0 }} unmountOnExit>
            <ul className="!ml-3 px-5 py-4 list-none bg-white rounded-lg max-w-[288px] shadow-[0px_8px_16px_0px_rgba(45,45,45,0.08),0px_4px_8px_0px_rgba(45,45,45,0.12),0px_0px_2px_0px_rgba(45,45,45,0.2)]">
              {menuList.map((item) => (
                <li
                  key={item.id}
                  title={item.name}
                  className="px-5 py-2 cursor-pointer rounded-lg hover:bg-web-blue-500/4"
                  onClick={() => handleScroll(item.id)}
                >
                  <span className="line-clamp-1">{item.name}</span>
                </li>
              ))}
            </ul>
          </Fade>
        </div>
      </ClickAwayListener>
    </div>
  );
};

export default GeneralMenu;
